module.exports = __webpack_public_path__ + "img/mini_logo.a6595677.webp";